import { jwtDecode } from 'jwt-decode';
import { TokenDecodedExtended, TokenMeta } from '../types';

export const getDecodedValue = (token: string): TokenDecodedExtended | null => {
  try {
    return jwtDecode<TokenDecodedExtended>(token);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    return null;
  }
};

export const getTokenMeta = (token: string): TokenMeta => {
  const decoded: TokenDecodedExtended | null = getDecodedValue(token);

  const isExpired = decoded ? new Date(decoded.exp * 1000) < new Date() : false;

  return { decoded, isExpired };
};
